// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form[data-v-5fb1b024]{width:100%}.form .form__section-title__advisor[data-v-5fb1b024]{margin:20px 0}.form .form__section-title__insured[data-v-5fb1b024]{margin:0}.form-actions[data-v-5fb1b024]{display:flex;flex-direction:column;margin:20px 0 0}.form-actions .plain[data-v-5fb1b024]{color:var(--c-original-green)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
